var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 96 960 960",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M479.862 1001q-88.138 0-165.5-33.5T179 876q-58-58-91-135.5T55 574q0-87 33.304-164.349 33.305-77.348 91.112-134.996 57.808-57.649 135.196-91.152T480.024 150q88.024 0 165.286 33.447 77.261 33.448 134.976 91Q838 332 872 409.5T906 574q0 89-33.404 166.658-33.404 77.657-91.382 135.295-57.977 57.637-135.596 91.342Q568 1001 479.862 1001Zm.138-94q138.375 0 234.688-96.812Q811 713.375 811 574q0-53.766-17-104.883T744 376L281 838q40.286 35.941 92.31 52.471Q425.334 907 480 907ZM217 773l461-462q-43.183-33.426-93.26-49.713Q534.662 245 480 245q-138.375 0-234.688 95.684Q149 436.369 149 574q0 55.013 18.287 105.915Q185.574 730.817 217 773Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.c065100c3896956f5a65344faa68d4a2.svg";
export { ForwardRef as ReactComponent };